import { render } from "./ViewInterpretationReports.vue?vue&type=template&id=08df6bbd&scoped=true"
import script from "./ViewInterpretationReports.vue?vue&type=script&lang=js"
export * from "./ViewInterpretationReports.vue?vue&type=script&lang=js"

import "./ViewInterpretationReports.vue?vue&type=style&index=0&id=08df6bbd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08df6bbd"]])

export default __exports__